@if (configs?.length > 0) {
  @for (itineraryStepDocumentConfig of configs; track itineraryStepDocumentConfig) {
    <div>
      <app-distribution-itinerary-step [config]="itineraryStepDocumentConfig"></app-distribution-itinerary-step>
    </div>
  }
} @else {
  <br />
  <p class="italic">There is nothing to configure</p>
}

